import { useConstant } from '@showroomjs/ui';
import { useCallback, useEffect, useRef } from 'react';
import { useStableCallback } from './callback';
export const usePreviewWindow = (onMessage) => {
    useMessage(onMessage, (ev) => ev.source === parent);
    useEffect(() => {
        parent.postMessage({
            type: 'ready',
        }, window.origin);
    }, []);
    const sendParent = useCallback(function sendMsgToParent(data) {
        try {
            parent.postMessage(data, window.origin);
        }
        catch (err) {
            if (data.type === 'log') {
                console.group('Fail to log data into panel');
                const level = data.level === 'fatal' ? 'error' : data.level;
                console[level](...(data.data || []));
                console.groupEnd();
                sendMsgToParent({
                    type: 'log',
                    level: 'fatal',
                    data: [`Data could not be logged. Check DevTools console.`],
                });
            }
            else {
                console.error(err);
            }
        }
    }, []);
    return {
        sendParent,
    };
};
export const useParentWindow = (onMessage) => {
    const targetRef = useRef(null);
    const messageQueue = useConstant(() => []);
    const isReadyRef = useRef(false);
    useMessage((msg) => {
        if (msg.type === 'ready') {
            isReadyRef.current = true;
            const targetWindow = targetRef.current && targetRef.current.contentWindow;
            messageQueue.forEach((msg) => {
                targetWindow.postMessage(msg, window.origin);
            });
        }
        else if (onMessage) {
            onMessage(msg);
        }
    }, (ev) => {
        if (targetRef.current) {
            return ev.source === targetRef.current.contentWindow;
        }
        return false;
    });
    const sendMessage = useCallback((data) => {
        if (!isReadyRef.current) {
            messageQueue.push(data);
            return;
        }
        const targetWindow = targetRef.current && targetRef.current.contentWindow;
        if (targetWindow) {
            targetWindow.postMessage(data, window.origin);
        }
    }, []);
    return {
        targetRef,
        sendMessage,
    };
};
const useMessage = (onMessage, additionalFilter) => {
    const onMessageCb = useStableCallback(onMessage);
    useEffect(() => {
        function onMsg(ev) {
            if (ev.origin === window.origin &&
                ev.data &&
                (!additionalFilter || additionalFilter(ev))) {
                onMessageCb(ev.data);
            }
        }
        window.addEventListener('message', onMsg);
        return () => window.removeEventListener('message', onMsg);
    }, []);
};
//# sourceMappingURL=frame-message.js.map